import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/my-downloads")({
  beforeLoad: () => {
    throw redirect({ to: "/my-courses" });
  },
});
